export default {
  //#region : Toast Handling :
  /**
   * Main Toast
   */
  showToast: (state, toast) => {
    const { color, timeout, message } = toast;

    state.toast = {
      message,
      color,
      timeout,
      show: true
    };
  },
  hideToast: (state) => {
    state.toast.show = false;
  },
  resetToast: (state) => {
    state.toast = {
      show: false,
      color: 'black',
      message: '',
      timeout: 3000
    };
  },
  //#endregion

  //#region : Dot Handling :
  /**
   * Shows or hides sig message
   * @param {*} state
   * @param {*} showDot
   */
  showDot: (state, showDot) => {
    state.dot.show = showDot;
  },
  /**
   * Sets dot values in state
   * @param {*} state
   * @param {*} dot
   */
  setDot: (state, dot) => {
    state.dot.id = dot.id;
    state.dot.message = dot.message;
    state.dot.xCoords = dot.xCoords;
    state.dot.yCoords = dot.yCoords;
    // reset callback
    state.dot.callback = null;
    state.dot.callbackLabel = null;
  },
  /**
   * Sets the Dot Callback
   * @param {*} state
   * @param {*} param1
   */
  setDotCallback: (state, { callback, callbackLabel }) => {
    state.dot.callback = callback;
    state.dot.callbackLabel = callbackLabel;
  },
  //#endregion

  //#region : Authentication :
  /**
   * Sets the value of showLoginDialog in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {boolean} value - The new value for showLoginDialog.
   */
  setShowLoginDialog(state, show) {
    state.showLoginDialog = show;
  },
  /**
   * Sets the value of showCreateAccountDialog in the state.
   * @param {*} state
   * @param {*} show
   */
  setShowCreateAccountDialog(state, show) {
    state.showCreateAccountDialog = show;
  },
  /**
   * Sets the value of forgotPasswordDialog in the state.
   * @param {*} state
   * @param {*} show
   */
  setShowForgotPasswordDialog(state, show) {
    state.showForgotPasswordDialog = show;
  },
  /**
   * Sets the value of authenticating in the state.
   * @param {*} state
   * @param {*} authenticating
   */
  setAuthenticating: (state, authenticating) => {
    state.authenticating = authenticating;
  },
  /**
   * Sets user data in state
   * @param {*} state
   * @param {*} user
   */
  setUser: (state, user) => {
    state.user = {
      email: user.email,
      isGuest: user.isGuest,
      isUser: user.isUser,
      id: user.id,
      guid: user.guid
    };
  }
  //#endregion
};
